<template>
  <ExternalQueryList
      headline="Article Tags"
      endpoint="/api/v2/content-article-tags"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentArticleTag => $router.push(getUrl(contentArticleTag))"
  >
    <template v-slot:default="{ row: contentArticleTag }">
      <td>
        <router-link :to="getUrl(contentArticleTag)">
          {{ contentArticleTag.attributes.name }}
        </router-link>
      </td>

      <td>
          {{ contentArticleTag.attributes.path }}
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/article-tags/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 10, text: 'Name'},
        {width: 10, text: 'Path'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentArticleTag) {
      return '/portals/' + this.portal.id + '/content/article-tags/' + contentArticleTag.id + '/edit'
    }
  }
}
</script>
